<template>
    <FilterLayout :advanceOption="false">
      <section data-test="filter-hcm-section">
        <div class="mt-2">
          <label class="from-label text-xxs text-gray-600" for="osm-select">HCM</label>
          <!-- <v-select
            data-test="hcm-select"
            id="hcm-select"
            v-model="filterState.hcm"
            :options="[]"
            :clearable="true"
            placeholder="กรุณาเลือก HCM"
            :appendToBody="true"
          >
            <template #no-options="">
              <p class="text-sm font-normal text-gray-500">
                ไม่พบข้อมูล
              </p>
            </template>
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
            </template>
          </v-select> -->
          <input type="text" class="form-control" placeholder="HCM" v-model="filterState.hcm" />
        </div>
      </section>
      <UsersSection
        :organize="filterState.organize"
        :sub_organize="filterState.sub_organize"
        :province="filterState.province"
        @update:organize="filterState.organize=$event"
        @update:sub_organize="filterState.sub_organize=$event"
        @update:province="filterState.province=$event"
      />
        <div class="flex justify-end mt-3">
            <button class="btn btn-outline-secondary mr-2" @click="resetState">
                ล้าง
            </button>
            <button class="btn btn-primary" @click="sendToStore">
                ค้นหา
            </button>
        </div>
    </FilterLayout>
</template>
<script setup>
import FilterLayout from "./layout/index.vue"
import { reactive, onMounted,} from "vue";
import { useStore } from "vuex";
import UsersSection from "./component/UsersSection.vue"

const INIT_FILTER_VALUE = {
  hcm: null,
  organize: null,
  sub_organize: null,
  province: null,
};

const store = useStore();
const filterState = reactive({ ...INIT_FILTER_VALUE });

onMounted(() => {
  Object.assign(
    filterState,
    JSON.parse(JSON.stringify(store.getters["hcmUserFilter/getAllFilter"]))
  );
});


const resetState = () => {
  const initFilter = JSON.parse(JSON.stringify(INIT_FILTER_VALUE))
  Object.assign(filterState, initFilter);
};
const sendToStore = () => {
  store.dispatch(
    "hcmUserFilter/setStore",
    JSON.parse(JSON.stringify(filterState))
  );
};


</script>